import { getCSSVariable } from "../../../../core/helpers/css-util.js";
import AbstractChartStrategy from "../../../../core/widgets/ChartWidget/AbstractChartStrategy.js";

/**
 * Implements a Strategy to render the bars on top of the P&L report.
 */
export default class IncomeStatementChartStrategy extends AbstractChartStrategy {
	_makeDatasets({ values: keyFigureValues }) {
		const barThickness = getCSSVariable(
			"--income-statement-chart-bar-thickness-in-px",
		);
		const borderWidth = getCSSVariable(
			"--income-statement-chart-bar-distance-in-px",
		);
		const borderColor = "#fff";

		return keyFigureValues.map((values) => {
			const data = values.map((keyFigureValue) =>
				keyFigureValue.getValue(),
			);

			const keyFigure = values[0].getComponent();

			return {
				label: keyFigure.getName(),
				data,
				backgroundColor: this._getBackgroundColorFor({ keyFigure }),
				borderColor,
				borderWidth,
				barThickness,
			};
		});
	}

	_getChartType() {
		return "bar";
	}

	_getChartOptions() {
		return {
			...super._getChartOptions(),
			scales: {
				x: { display: false },
				y: { display: false },
			},
		};
	}

	_getBackgroundColorFor({ keyFigure }) {
		return (
			getCSSVariable(
				`--income-statement-chart-${keyFigure.getId()}-color`,
			) || "blue"
		);
	}
}
